export const categories = [
  "All Services",
  "Digital Marketing Services",
  "Development Services",
  "Writing Services"
];
const services = [
  {
    name: "FB Ad account Setup",
    img: "https://picsum.photos/400",
    price: "5000",
    category: categories[1]
  },
  {
    name: "Google Ad account Setup",
    img: "https://picsum.photos/400",
    price: "5000",
    category: categories[1]
  },
  {
    name: "Linkedin Ad account Setup",
    img: "https://picsum.photos/400",
    price: "5000",
    category: categories[1]
  },
  {
    name: "Twitter Ad account Setup",
    img: "https://picsum.photos/400",
    price: "5000",
    category: categories[1]
  },
  {
    name: "Quora Ad account Setup",
    img: "https://picsum.photos/400",
    price: "5000",
    category: categories[1]
  },
  {
    name: "Sales Funnel Design",
    img: "https://picsum.photos/400",
    price: "10000",
    category: categories[1]
  },
  {
    name: "Local SEO Service",
    img: "https://picsum.photos/400",
    price: "15000",
    category: categories[1]
  },
  {
    name: "Social Media Optimization",
    img: "https://picsum.photos/400",
    price: "10000",
    category: categories[1]
  },
  {
    name: "WordPress Website Developement",
    img: "https://picsum.photos/400",
    price: "15000",
    category: categories[2]
  },
  {
    name: "Shopify Website Developement",
    img: "https://picsum.photos/400",
    price: "25000",
    category: categories[2]
  },
  {
    name: "Shopify App Developement",
    img: "https://picsum.photos/400",
    price: "35000",
    category: categories[2]
  },
  {
    name: "Landing Page Development (With Payment Gateway)",
    img: "https://picsum.photos/400",
    price: "15000",
    category: categories[2]
  },
  {
    name: "Landing Page Development (Without Payment Gateway)",
    img: "https://picsum.photos/400",
    price: "10000",
    category: categories[2]
  },
  {
    name: "Articles & Blog Posts",
    img: "https://picsum.photos/400",
    price: "",
    category: categories[3]
  },
  {
    name: "Translation",
    img: "https://picsum.photos/400",
    price: "",
    category: categories[3]
  },
  {
    name: "Ad Copy",
    img: "https://picsum.photos/400",
    price: "",
    category: categories[3]
  },
  {
    name: "Sales Copy",
    img: "https://picsum.photos/400",
    price: "",
    category: categories[3]
  },
  {
    name: "Social Media Copy",
    img: "https://picsum.photos/400",
    price: "",
    category: categories[3]
  },
  {
    name: "Email Copy",
    img: "https://picsum.photos/400",
    price: "",
    category: categories[3]
  },
  {
    name: "UX Writing",
    img: "https://picsum.photos/400",
    price: "",
    category: categories[3]
  }
];

export default services;
